export const LINK_TYPE = {
  ID: 'id',
  URL: 'url',
  SECTION: 'section',
};

export const DROPDOWN_CLASS = {
  STYLE1: 'dropdown-style1',
  STYLE2: 'dropdown-style2',
};

export const CAROUSEL_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
  NONE: 'none',
};

export const CAROUSEL_MODE = {
  CAROUSEL: 'carousel',
  SLIDESHOW: 'slideshow',
};

export const THUMBS_POSITION = {
  COVER: 'cover',
  BOTTOM: 'bottom',
};

export const PAGE_TYPE = {
  ENQUIRY: 'enquiry',
  BROCHURE: 'brochure',
  PREORDERBROCHURE: 'preorderbrochure',
  SHORTLIST: 'shortlist',
  COMPETITION: 'competition',
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  BLOG_ENQUIRY: 'blog_enquiry',
};

export const NULLVALUES = {
  // How the C# backend represents an unset int/date internally. INT arrives in API responses but must
  // never be sent back in a request - see INT_WIRE.
  INT: -2147483648,
  DATE: '0001-01-01T00:00:00',
  // Wire-safe stand-in for INT. Our WAF blocks requests containing a 32-bit integer extreme, so any
  // "not set" integer that travels to the backend uses this instead. Incoming payloads are normalised
  // by utils/wireSafeInts.js and the API maps it back to its own null-int sentinel.
  // Mirrors TTT.BLL.Constants.NullIntWire on the backend.
  INT_WIRE: -1,
};
